import { AbstractContentState, useCmsContent } from '@cp-shared-15/frontend-integration';
import { ErrorPage } from 'cpie-common';
import { fetchUnauthorizedErrorPage } from './UnauthorizedErrorPageSlice';
import { UnauthorizedErrorPageContentSelector } from './UnauthorizedErrorPageContentSelector';

export function useUnauthorizedErrorPage(): AbstractContentState<ErrorPage> {
    return useCmsContent(fetchUnauthorizedErrorPage, UnauthorizedErrorPageContentSelector);
}
